<section class="services">
  <h1 class="page-title">Our Plumbing Services</h1>

  <article
    class="service-row"
    *ngFor="let service of services; let i = index"
    #svcSection
    [id]="service.slug"
    [ngClass]="{ reverse: i % 2 === 1, 'light-grey': i % 2 === 0 }"
  >
    <!-- copy/text -->
    <div class="service-content">
      <h2 class="title">{{ service.title }}</h2>
      <p class="description">{{ service.description }}</p>

      <!-- CTA dials straight out -->
      <a
        class="cta"
        [href]="'tel:' + service.phone"
        attr.aria-label="Phone {{ service.phone }}"
        >{{ service.cta }}</a
      >
    </div>

    <!-- image -->
    <div class="service-image">
      <img
        [src]="service.image"
        [alt]="service.title + ' illustration'"
        loading="lazy"
      />
    </div>
  </article>
</section>

<axis-faq
  [faqImageUrl]="'/images/faq.png'"
  [faqImageAlt]="'Custom FAQ Image'"
  [faqItems]="faqItem"
></axis-faq>
